import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core';
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';

import { IconComponent } from '@shared/components/icon/icon.component';
import { AgSetColumnsVisible } from '@shared/utils';

export interface AgQuarterCloseCollapsableHeaderParams extends IHeaderParams {
  columns: string[];
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent],
  template: `
    <div class="flex items-center space-x-2">
      @if (params.template) {
        <div [innerHTML]="params.template"></div>
      }

      @if (columns.length) {
        <button class="aux-link flex items-center no-underline" (click)="onToggle()">
          <aux-icon
            class="text-aux-gray-darkest"
            [name]="collapsed() ? 'ChevronRight' : 'ChevronLeft'"
          />
        </button>
      }
    </div>
  `,
})
export class AgQuarterCloseCollapsableHeaderComponent implements IHeaderAngularComp {
  collapsed = signal(true);

  columns: string[] = [];
  params!: AgQuarterCloseCollapsableHeaderParams;

  agInit(params: AgQuarterCloseCollapsableHeaderParams) {
    this.params = params;
    this.columns = params.columns;
  }

  onToggle() {
    const isCollapsed = this.collapsed();

    AgSetColumnsVisible({
      gridApi: this.params.api,
      keys: this.columns,
      visible: isCollapsed,
    });
    this.collapsed.set(!isCollapsed);
  }

  refresh(): boolean {
    return false;
  }
}
